import { Navbar } from './navbar';

const props = [];

export const NavbarDirective = (reactDirective) => reactDirective(Navbar, props, null);
NavbarDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('navbar', NavbarDirective);
